<template>
  <div class="tableStyle">
    <div class="tableBox">
      <div class="tableStyle-right">
        <div class="carStateTable">
          <el-scrollbar>
            <div class="rightAll">
              <div class="rightAll-btn">
                <el-button
                  v-if="isPrimaryKey('ROLEMANAGEMENT_EDIT')"
                  type="text"
                  @click="editRole"
                  :disabled="this.selected.length == 0"
                  >{{ $t("common.btn.edit") }}</el-button
                >
                <el-button
                  v-if="isPrimaryKey('ROLEMANAGEMENT_DELETE')"
                  type="text"
                  @click="deleteRole"
                  :disabled="this.selected.length == 0"
                  >{{ $t("common.btn.delete") }}</el-button
                >
                <el-button
                  v-if="isPrimaryKey('ROLEMANAGEMENT_ADD')"
                  type="text"
                  @click="addRole"
                  >{{ $t("common.btn.add") }}</el-button
                >
                <!-- <el-button @click="ListSetting" type="text">{{$t('PlatformSettings.listSet')}}</el-button>
                <i-column
                  :listData="columns"
                  @changeSort="changeSort"
                  ref="listSet"
                ></i-column> -->
              </div>
              <i-table
                :list="list"
                :height="height"
                ref="carTable"
                @handleSelectionChange="handleSelectionChange"
                :options="option"
                :columns="columns"
                :operates="operates"
              ></i-table>
              <IPagination ref="page" @PageFun="changeSize"></IPagination>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <el-dialog
        width="800px"
        :before-close="closeDia"
        class="addDialong"
        :title="diaTitle"
        :visible.sync="dialogFormVisible"
        :close-on-click-modal="false"
      >
        <el-form :rules="rules" ref="form" :model="form">
          <el-form-item
            prop="name"
            :label="$t('PlatformSettings.roleName') + ':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.name"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item
                prop="menu"
                :label="$t('PlatformSettings.menu') + ':'"
                :label-width="formLabelWidth"
              >
                <el-scrollbar>
                  <el-tree
                    :data="data"
                    show-checkbox
                    node-key="id"
                    ref="tree"
                    :expand-on-click-node="false"
                    :default-expanded-keys="checkKeys"
                    :default-checked-keys="checkKeys"
                    :props="defaultProps"
                  >
                  </el-tree>
                </el-scrollbar>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                prop="appMenu"
                :label="$t('PlatformSettings.appMenu') + ':'"
                :label-width="formLabelWidth"
              >
                <el-scrollbar>
                  <el-tree
                    :data="appData"
                    show-checkbox
                    node-key="id"
                    ref="appTree"
                    :expand-on-click-node="false"
                    :default-expanded-keys="appCheckKeys"
                    :default-checked-keys="appCheckKeys"
                    :props="defaultProps"
                  >
                  </el-tree>
                </el-scrollbar>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancle('form')">{{
            $t("common.btn.cancel")
          }}</el-button>
          <el-button size="small" type="primary" @click="submitForm('form')">{{
            $t("common.btn.confirm")
          }}</el-button>
        </div>
      </el-dialog>
      <el-dialog
        :title="$t('PlatformSettings.menuDetail')"
        :visible.sync="dialogVisibleTree"
        width="800px"
        class="treeDialong"
        :before-close="handleCloseTree"
        :close-on-click-modal="false"
      >
        <div style="height: 420px">
          <el-scrollbar>
            <el-row :gutter="20" style="margin-left: 0;margin-right: 0;">
              <el-col :span="12">
                <el-tree
                  :data="treeData"
                  show-checkbox
                  node-key="id"
                  ref="treeData"
                  :expand-on-click-node="false"
                  :default-expanded-keys="checkKeys"
                  :default-checked-keys="checkKeys"
                  :props="defaultProps"
                >
                </el-tree>
              </el-col>
              <el-col :span="12">
                <el-tree
                  :data="appTreeData"
                  show-checkbox
                  node-key="id"
                  ref="appTreeData"
                  :expand-on-click-node="false"
                  :default-expanded-keys="appCheckKeys"
                  :default-checked-keys="appCheckKeys"
                  :props="defaultProps"
                >
                </el-tree>
              </el-col>
            </el-row>
          </el-scrollbar>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import roleManagement from "./roleManagement";
export default roleManagement;
</script>

<style lang="less" scoped>
@import "../../../assets/styles/Style.less";
</style>
